import Cookie from 'js-cookie';

//价格转换
export function convertPrice(price, fixFlag) {
  if (!price) return '0';
  price = Number(price);
  if (price < 100) {
    return fixFlag ? '0' : '0.00';
  } else {
    price = Math.floor(price / 100) * 100;
    return fixFlag ? Number.parseInt(price) / 10000 : (Number.parseInt(price) / 10000).toFixed(2);
  }
}

//按位与解析医生标签，返回Boolean值 sign: 十进制; num:移位的位数
export function decodeSign(sign, num) {
  let _sign = sign & Math.pow(2, num);
  return _sign > 0;
}

export function getSignUrl() {
  const agent = window.navigator.userAgent.toLowerCase();
  const ios = agent.match(/(iphone|ipad|ios|ipod)/);
  if (ios && ios[0]) {
    return window._entrance_url;
  } else {
    return window.location.href;
  }
}

/**
 * @desc 格式化一个对象为字符串如 name=pat&city_no=020&old=99;
 * @param data string
 **/
export function parseParams(data) {
  if (data == null) {
    return '';
  }
  let list = [];
  for (let item in data) {
    list.push(`${item}=${data[item]}`);
  }
  return list.join('&');
}

/**
 * @description 参数处理,处理一个对象,剔除其中值为空的项,返回有值的项.用在发送参数的时候处理参数对象.
 * @param object 输入的参数对象
 * @returns {*}
 */
export function handleParams(object) {
  if (typeof object !== 'object') return false;
  let keys = Object.keys(object),
    res = {};
  if (keys.length) {
    keys.forEach(item => {
      switch (typeof object[item]) {
        case 'number': //数字0保留
          if (object[item] || object[item] === 0) {
            res[item] = object[item];
          }
          break;
        case 'boolean': //false保留
          res[item] = object[item];
          break;
        default:
          //目标参数value存在(不为null/undefined,或空字符串)
          if (object[item]) {
            res[item] = object[item];
          }
      }
    });
  }
  return res;
}

//缓存处理
export const cacheCtx = {
  _map: new Map(),
  getCache(ql, params) {
    //缓存处理
    let cacheKey = JSON.stringify(params);
    if (this._map.has(ql)) {
      let cacheList = this._map.get(ql);
      if (cacheList[cacheKey]) {
        return cacheList[cacheKey];
      } else {
        console.log('未获取到', cacheList, cacheKey);
      }
    }
  },
  setCache(ql, params, res) {
    let cacheKey = JSON.stringify(params);
    let cacheList = this._map.get(ql);
    if (cacheList) {
      cacheList[cacheKey] = res;
    } else {
      this._map.set(ql, {[cacheKey]: res});
    }
  },
};

export function handleError(promise) {
  return promise
    .then(data => {
      if (data.code === 200 || (+data.status === 0 && data.status !== '')) {
        return [null, data];
      } else {
        return [data.message || data.detail, null, data];
      }
    })
    .catch(err => {
      return [JSON.stringify(err), null];
    });
}

/**
 * @description 是否为浏览器环境
 * @return  Boolean
 */
export function isBrowser() {
  return !!(typeof document !== 'undefined' && window);
}

/**
 * @desc 判断是否是微信内置浏览器
 * @return  Boolean
 **/
export function isWeiXin() {
  if (typeof window == 'undefined') return false;
  let ua = window.navigator.userAgent.toLowerCase();
  return (/MicroMessenger/i.test(ua));
}

/**
 * @desc 判断是否是app环境,是则输出app类型,否则输出空
 * @return string
 **/
export function isMobileApp() {
  if (typeof window == 'undefined') return false;
  let ua = window.navigator.userAgent.toLowerCase();
  if (/GSTApp/i.test(ua)) {
    if (/Android/i.test(ua)) {
      return 'android';
    } else if (/iOS/i.test(ua)) {
      return 'ios';
    }
  } else {
    return '';
  }
}

/**
 * @desc 判断是否为第三方平台,是则输出平台名,否则输出空
 * @return string
 **/
export function isThirdParty() {
  if (typeof window == 'undefined') return '';
  let channel = Cookie.get('channel');
  let result = Cookie.get('platform');
  if (channel && channel.toLowerCase() === 'gst') {
    if (!result) return '';
    return result;
  } else {
    return channel;
  }
}

/**
 * @description 将对象转换为URL字符串,方便发送或存储
 * @param o 将要转为URL参数字符串的对象
 * @param key URL参数字符串的前缀
 * @param encode true/false 是否进行URL编码,默认为true
 * @return string URL参数字符串
 **/
export function objToUrlString(o, key, encode) {
  if (o == null) return '';
  var fn = function (obj, key, encode) {
    var paramStr = '',
      t = typeof obj;
    if (t == 'string' || t == 'number' || t == 'boolean') {
      paramStr += '&' + key + '=' + (encode == null || encode ? encodeURIComponent(obj) : obj);
    } else {
      for (var i in obj) {
        var k = key == null ? i : key + (obj instanceof Array ? '[' + i + ']' : '.' + i);
        paramStr += fn(obj[i], k, encode);
      }
    }
    return paramStr;
  };
  var result = fn(o, key, encode);
  return result.substr(1);
}

export let storage = {
  checkWindow() {
    if (!window) {
      console.warn('[Storage] === Storage can ONLY used in browser.');
      return false;
    }
    return true;
  },
  checkSupport(type) {
    let winFlag = this.checkWindow();
    if (winFlag && window[type]) {
      return true;
    } else {
      console.warn(`[Storage] === ${type} Storage is NOT supported.`);
      return false;
    }
  },
  checkType(type) {
    if (type && type == 'session') {
      return 'sessionStorage';
    } else {
      return 'localStorage';
    }
  },
  set(key, value, type) {
    let target = this.checkType(type);
    if (this.checkSupport(target)) {
      return window[target].setItem(key, JSON.stringify(value));
    }
  },
  get(key, type) {
    let target = this.checkType(type);
    if (this.checkSupport(target)) {
      if (window[target][key] && window[target][key] !== 'undefined') {
        return JSON.parse(window[target][key]);
      } else {
        return window[target][key];
      }
    }
  },
  remove(key, type) {
    let target = this.checkType(type);
    if (this.checkSupport(target)) {
      if (window[target][key] && window[target][key] !== 'undefined') {
        return window[target].removeItem(key);
      }
    }
  },
};

const warnings = '==========Store 只能在浏览器使用 =============';

function hasWindow() {
  if (!window) {
    console.warn(warnings);
    return false;
  }
  return true;
}
export function saveObject(key, object) {
  if (!hasWindow()) return;
  window.localStorage[key] = JSON.stringify(object);
}
export function loadObject(key) {
  if (!hasWindow()) return;
  var objectString = window.localStorage[key];
  return objectString == null ? null : JSON.parse(objectString);
}
export function deleteObject(key) {
  if (!hasWindow()) return;
  window.localStorage[key] = null;
}
export function clear() {
  if (!hasWindow()) return;
  window.localStorage.clear();
}

export function locationTo(url) {
  location.href = url;
}

/**
 * @desc 链接数组对象里的某个属性,并返回一个数组，如 [{mis_doctor_id:123},{mis_doctor_id:3497}] 返回数组[123, 3497]
 * @param arr
 * @param prop
 * @returns {Array}
 */
export function getArrProp(arr, prop) {
  let result = [];
  if (!arr) return result;
  for (let i = 0; i < arr.length; i++) {
    result.push(arr[i][prop]);
  }
  return result;
}

/**
 * @desc 从cookie中取用户信息,返回用户对象
 * @returns {{user_id: (*|boolean), login_id: (*|boolean), open_id: (*|boolean), user_role: (*|boolean), cur_role: (*|boolean)}}
 */
export function getUser() {
  if (typeof document !== 'undefined' && window) {
    return {
      user_id: Cookie.get('userid') || Cookie.get('user_id') || '',
      mobile:
        Cookie.get('mobile_number') || Cookie.get('mobile_phone') || Cookie.get('uin') || Cookie.get('userid') || '',
      login_id: Cookie.get('loginid') || Cookie.get('login_id') || '',
      open_id: Cookie.get('openid') || Cookie.get('open_id') || '',
      token: Cookie.get('wxCacheKey') || Cookie.get('wxCacheKey') || '',
      wxSource: Cookie.get('wxSource') || Cookie.get('wxSource') || '1', //微信公众号来源，用于区分大小号
      wxDomain: Cookie.get('wxDomain') || Cookie.get('wxDomain') || '', //微信认证域名
      user_role: Cookie.get('user_role') || '', //用户所有角色:十进制合成值,多角色累加得到
      cur_role: Cookie.get('role') || '', //当前角色: 位移值,1<<x
      doctor_id: Cookie.get('doctor_id') || '', //如果是医生,则有医生id
      assistant_id: Cookie.get('assistant_id') || '', //如果是医助,则有医助id
      user_image: Cookie.get('user_image') || '', //用户头像缓存
      channel: Cookie.get('channel') || '', //渠道
      userLocation: Cookie.get('userLocation') ? JSON.parse(Cookie.get('userLocation')) : '',
    };
  } else {
    return {};
  }
}

//清理当前用户信息
export function cleanUser() {
  let aCookieList = [
    'userid',
    'user_id',
    'mobile_number',
    'mobile_phone',
    'openid',
    'open_id',
    'WXCacheKey',
    'wxCacheKey',
    'city',
    'user_role',
    'role',
    'doctor_id',
    'assistant_id',
    'user_image',
    'channel',
    'userLocation',
    'env_clinic_id',
  ];
  aCookieList.forEach(key => {
    Cookie.remove(key, {domain: window._second_domain_});
    Cookie.remove(key);
  });

  storage.remove('userLocation', 'local');
  storage.remove('Location', 'local');
  storage.remove('AREA-INFO', 'local');    //清理位置信息
  storage.remove('PATIENT_INFO', 'local'); //清理默认就诊人
  storage.remove('selectCityId', 'local');
  storage.remove('vipCardList', 'local');
  //storage.remove('REGISTRATION_INFO','local'); //清理预约信息
  //storage.remove('SearchHistory','local');     //清理本机搜索记录
  //if(window.m&&window.m.appLogOut){window.m.appLogOut();} //通知App销毁用户凭据
}

//platform detect
export function detectPlatform() {
  if (isThirdParty()) {
    return isThirdParty();
  } else if (isMobileApp()) {
    return isMobileApp();
  } else if (isWeiXin()) {
    return 'weixin';
  } else {
    return 'web';
  }
}

/**
 * 手机号脱敏处理
 * @param phone
 * @returns {string | void | *}
 */
export function safePhone(phone) {
  if (!phone) return phone;
  const pat = /(\d{3})\d*(\d{4})/;
  return `${phone}`.replace(pat, '$1****$2');
}

//姓名脱敏
export function safeName(str) {
  if (typeof str == 'string') {
    let top = str.substr(0, 1);
    let end = str.substr(-1);
    if (str.length > 2) {
      let center = '';
      for (var i = 0; i <= str.length - 3; i++) {
        center += '*';
      }
      return top + center + end;
    } else if (str.length == 2) {
      return top + '*';
    }
  }
  return str;
}

/**
 * @description url字符串转换成对象
 * @param string
 * @returns {{}}
 */
export function urlStringToObj(string) {
  var params = {},
    q = string ? string : window.location.search.substring(1),
    e = q.split('&'),
    l = e.length,
    f,
    i = 0;
  for (i; i < l; i += 1) {
    f = e[i].split('=');
    params[f[0]] = decodeURIComponent(f[1]);
  }
  return params;
}

/**
 * 跳转去支付页面, sParams 是原跳转到支付页面需要的链接上的参数
 */
export function goPay(sParams) {
  const from = localStorage.getItem('from');
  if (from === 'omo') {
    if (isWeiXin()) {
      //判断是否是微信环境
      window.wx.miniProgram.getEnv(function (res) {
        if (res.miniprogram) {
          //小程序环境
          const {deal_id, user_id} = urlStringToObj(sParams);

          //H5向小程序传值的方法会在特定的时间触发，因此需要我们手动写一个跳转（也可以写后退和摧毁，分享，以需求而定）
          window.wx.miniProgram.redirectTo({
            url: `/pages/checkoutCounter/index?deal_id=${deal_id}&user_id=${user_id}&from=1`, //这里是小程序页面
          });
        } else {
          //非小程序环境下逻辑
          console.log('不在小程序中');
        }
      });
    }
  } else {
    let env = process.env.REACT_APP_ENV;
    let devHost = '',
      testHost = window.isThird ? '//test-third.gstyun.cn' : '//test.gstyun.cn',
      stgHost = window.isThird ? '//stg-third.gstyun.cn' : '//stg.gstyun.cn',
      prodHost = window.isThird ? '//third.gstyun.cn' : '//weixin.gstyun.cn';
    let payHost = /^test|dev|development$/.test(env)
      ? devHost
      : env === 'test'
      ? testHost
      : env === 'stg'
      ? stgHost
      : prodHost;
    window.location.href = `${payHost}/pay/paycenter${sParams}`;
  }
}

// 根据环境购买会员
export function getEnv(success) {
  const ua = window.navigator.userAgent.toLowerCase();
  if (/MicroMessenger/i.test(ua)) {
    window.wx.miniProgram.getEnv(function (res) {
      if (res.miniprogram) {
        //小程序环境
        success && success('miniprogram');
      } else {
        //非小程序环境下逻辑
        console.log('不在小程序中');
        success && success('h5');
      }
    });
  } else if (ua.indexOf('iospatientapp') >= 0) {
    success && success('iOSApp');
    // app 环境
  } else if (ua.indexOf('androidpatientapp') >= 0) {
    success && success('androidApp');
  } else {
    success && success('web');
  }
}

export function memberName(level) {
  let levelName = '固享';
  switch (Number(level)) {
    case 0:
      levelName = '普通';
      break;
    case 1:
      levelName = '固享';
      break;
    case 2:
      levelName = '康享';
      break;
    case 3:
      levelName = '优享';
      break;
    case 4:
      levelName = '乐享';
      break;
    case 5:
      levelName = '尊享';
      break;
    default:
      levelName = '普通';
  }
  return levelName;
}

export const timeTypeText = {
  1: '月',
  2: '季度',
  3: '半年',
  4: '年',
  5: '2年',
  6: '3年',
};

export const discount = {
  1: '9.5',
  2: '9',
  3: '8.8',
  4: '8.5',
  5: '8.5',
};

export const getOssUrl = name => {
  return `https://wx-gstzy.oss-cn-shenzhen.aliyuncs.com/mobile/images/${name}.png`;
};

//按位解析位和,返回array
export function decodeSignList(signSum, map) {
  let result = [];
  Object.keys(map).forEach(item => {
    if (decodeSign(signSum, item)) {
      result.push(map[item]);
    }
  });
  return result;
}

// 拆分金额为数组 9.00 -> ['9', '00'],
export const splitMoney = money => {
  if (money != 0 && !money) return;
  let moneyStr = String(money);
  if (Math.floor(money) === money) {
    moneyStr += '.0';
  }
  return moneyStr.split('.');
};

export const removeEmoji = (content) => {
  return content.replace(/(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g, "");

}

export const hasEmoji = (str) => {
  return /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g.test(str);
}

